/**
 * Pure helpers for action-advice UI binding / late-response safety.
 * Advice is shown only when the response binding matches the current selection.
 */

export function selectionBinding(selected) {
  if (!selected) return null;
  return {
    proposal_id: selected.id,
    revision: selected.revision,
    content_hash: selected.content_hash,
  };
}

export function adviceMatchesSelection(selected, advice) {
  if (!selected || !advice || advice.enabled === false) return false;
  const b = advice.binding;
  if (!b) return false;
  return (
    b.proposal_id === selected.id &&
    b.revision === selected.revision &&
    b.content_hash === selected.content_hash
  );
}

/**
 * Decide whether a fetched advice payload may update UI state.
 * requestId must equal the generation active when this response is applied.
 */
export function shouldAcceptAdviceResponse({
  selected,
  advice,
  requestId,
  activeRequestId,
}) {
  if (requestId !== activeRequestId) return false;
  if (!selected) return false;
  if (!advice || advice.enabled === false) return false;
  // Unavailable responses still need matching binding when present.
  if (advice.binding && !adviceMatchesSelection(selected, advice)) return false;
  if (!advice.binding && advice.available) return false;
  return true;
}

export function unavailableAdviceFallback(selected) {
  const binding = selectionBinding(selected);
  return {
    enabled: true,
    available: false,
    label: "Advies niet beschikbaar",
    ...(binding ? { binding } : {}),
  };
}
